export type ContentLocaleVisibility = {
  en: boolean;
  fa: boolean;
};

export const DEFAULT_CONTENT_LOCALE_VISIBILITY: ContentLocaleVisibility = {
  en: true,
  fa: true,
};

const HEX_COLOR_RE = /^#([0-9A-F]{6})$/;

export function normalizeArticleColor(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim().toUpperCase();
  if (!trimmed) return null;
  const normalized = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
  return HEX_COLOR_RE.test(normalized) ? normalized : null;
}

export function isValidArticleColor(value: unknown): value is string {
  return typeof value === "string" && HEX_COLOR_RE.test(value);
}

export function getContentLocaleVisibility(
  meta: unknown,
): ContentLocaleVisibility {
  const source =
    meta && typeof meta === "object" && !Array.isArray(meta)
      ? (meta as Record<string, any>).visibility
      : null;

  return {
    en:
      typeof source?.en === "boolean"
        ? source.en
        : DEFAULT_CONTENT_LOCALE_VISIBILITY.en,
    fa:
      typeof source?.fa === "boolean"
        ? source.fa
        : DEFAULT_CONTENT_LOCALE_VISIBILITY.fa,
  };
}

export function withContentLocaleVisibility(
  meta: unknown,
  visibility: Partial<ContentLocaleVisibility>,
) {
  const base =
    meta && typeof meta === "object" && !Array.isArray(meta)
      ? { ...(meta as Record<string, any>) }
      : {};

  return {
    ...base,
    visibility: {
      ...getContentLocaleVisibility(base),
      ...visibility,
    },
  };
}

export function isContentLocaleVisible(
  meta: unknown,
  locale: "en" | "fa",
): boolean {
  return getContentLocaleVisibility(meta)[locale];
}
